import { Item } from '../../types'
import * as Styles from './styles'

type Props = {
  items: Array<Item | undefined>
  borderTop?: boolean
}

export const icons = {
  tick: <Styles.TickIcon />,
  template: <Styles.TemplateIcon />,
  writing: <Styles.WritingIcon />,
  word: <Styles.WordIcon />,
  customization: <Styles.CostumizationIcon />,
}

export const StepItems = ({ items, borderTop }: Props) => {
  return (
    <Styles.Items>
      {items?.map(item => {
        return (
          <Styles.Item key={item?.header} borderTop={borderTop}>
            {icons[item?.icon as keyof typeof icons]}
            <Styles.ItemText>
              <Styles.ItemHeader>{item?.header}</Styles.ItemHeader>
              <Styles.ItemDescription>{item?.description}</Styles.ItemDescription>
            </Styles.ItemText>
          </Styles.Item>
        )
      })}
    </Styles.Items>
  )
}
